module.exports = __webpack_public_path__ + "static/img/emhyr_emperor.67c0e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/emhyr_emperor.png
// module id = T/dl
// module chunks = 0